import React from "react";

import { useActiveOrMainShippingZone } from "../../../../../providers/shippingZones";
import { useGetCustomersChoiceProductsQuery, useGetNewestProductsQuery } from "../../../../../providers/products";
import ProductShelf from "../ProductShelf";

type AddToOrderProductShelfProps = {
  className?: string;
};

const AddToOrderProductShelf = ({ className }: AddToOrderProductShelfProps) => {
  const { activeShippingZone } = useActiveOrMainShippingZone();

  const getCustomersChoiceProductsEnabled = !!activeShippingZone.id;

  const { data: customersChoiceProducts, isLoading: isCustomersChoiceProductsRefetchingLoading } =
    useGetCustomersChoiceProductsQuery(
      {
        zoneId: activeShippingZone.id,
      },
      { enabled: getCustomersChoiceProductsEnabled },
    );

  const getNewestProductsEnabled = !!customersChoiceProducts?.products?.length;

  const { data: newestProducts, isLoading: isNewestProductsLoading } = useGetNewestProductsQuery(
    {
      zoneId: activeShippingZone.id,
    },
    {
      enabled: getNewestProductsEnabled,
    },
  );
  const isLoading =
    (isNewestProductsLoading && getNewestProductsEnabled) ||
    (isCustomersChoiceProductsRefetchingLoading && getCustomersChoiceProductsEnabled);

  const items = customersChoiceProducts?.products ?? newestProducts?.products ?? [];

  if (items.length === 0) {
    return null;
  }

  return (
    <ProductShelf
      className={className}
      isLoading={isLoading}
      title={"Добавить к заказу"}
      items={items}
      titleClassName="!text-sm text-[#292929]"
    />
  );
};

export default AddToOrderProductShelf;
